module.exports = __webpack_public_path__ + "img/BRAVO_9.1d600211.jpg";